import Inspector from './inspector';
const { RichText } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { title, text, margin, color, colorTitle, background, padding } =
    attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section
        className={`InfoBox ${margin} ${background}   Container-block-pd-${padding}`}
      >
        <div className="Container">
          <div className={`InfoBox-title margin-extra-small ${colorTitle} `}>
            <RichText
              tagName="h2"
              className="Typography text center margin-none"
              value={title}
              placeholder="Informações legais"
              keepPlaceholderOnFocus
              onChange={(title) => setAttributes({ title })}
            />
          </div>
          <div className={color}>
            <RichText
              tagName="p"
              value={text}
              placeholder="Text aqui"
              className={`Typography text center margin-none`}
              keepPlaceholderOnFocus
              onChange={(text) => setAttributes({ text })}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Edit;
